const jsonToFormData = (json: Object) => Object.entries(json).reduce((fd, [key, value]) => (fd.append(key, value), fd), new FormData());

export default jsonToFormData;